import styled from '@emotion/styled';
import { theme } from '../../styles';

export const FooterWrapper = styled.div`
  padding: 60px 10px 10px;
  max-width: ${theme.maxWidthMobile};
  margin: 0 auto;

  @media (min-width: ${theme.breakpoints.md}) {
    padding: 81px 0 140px;
    max-width: ${theme.scale(theme.maxWidthDesktop)};
  }
`;

export const FooterContainerMain = styled.div`
  display: flex;
  width: 100%;
  height: auto;
  flex-direction: column;
  position: relative;

  @media (min-width: ${theme.breakpoints.m}) {
    padding: 0px 0px 42px 0px;
    flex-direction: row;
    align-items: center;
  }

  .Footer__Contact {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    margin: 0;

    @media (min-width: ${theme.breakpoints.m}) {
      margin-right: ${theme.scale('40px')};
      white-space: pre-wrap;
      margin-bottom: 0px;
    }
  }

  .Footer__MailTo-button {
    cursor: pointer;
    font-weight: 400;
  }

  .Footer__Logo {
    display: flex;
    width: 100%;
    margin-bottom: 30px;

    @media (min-width: ${theme.breakpoints.m}) {
      height: 100%;
      flex-direction: column;
      margin-bottom: ${theme.scale('70px')};
    }
  }

  .Footer__Container-Logo {
    height: 100%;
    display: flex;
    margin-bottom: 30px;

    @media (min-width: ${theme.breakpoints.m}) {
      min-width: 335px;
      margin-bottom: 0px;
    }

    @media (min-width: ${theme.breakpoints.l}) {
      min-width: 425px;
    }

    .Header__Logo {
      width: 100%;
      width: 90px;
      margin-right: auto;
    }
  }

  .Footer__Content {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    position: relative;

    @media (min-width: ${theme.breakpoints.m}) {
      width: 80%;
    }
  }

  .Footer__Contact-container {
    display: flex;
    width: 100%;
    flex-direction: column;
    justify-content: space-between;

    @media (min-width: ${theme.breakpoints.m}) {
      width: 100%;
      flex-direction: row;
    }
  }

  .Footer__Report-container {
    position: absolute;
    background-color: ${theme.colors.primaryred};
    font-family: ${theme.fontFamily.secondary};
    font-size: ${theme.fonts.m_small};
    font-weight: 500;
    top: -75px;
    right: 0;

    @media (min-width: ${theme.breakpoints.m}) {
      font-size: ${theme.scale(theme.fonts.m)};
      bottom: -25px;
      right: auto;
      top: auto;
    }

    a {
      margin-bottom: 0px;
      padding-right: 2px;
      padding-left: 2px;
      color: white;
    }
  }

  .Footer__SocialMedia {
    display: flex;
  }

  .Footer__text {
    line-height: 20px;
    font-family: ${theme.fontFamily.secondary};
    font-weight: 400;
    text-transform: uppercase;
    margin-bottom: 0px;
    width: 65%;

    @media (min-width: ${theme.breakpoints.m}) {
      width: auto;
      line-height: ${theme.scale('30px')};
      max-width: 225px;
    }
  }

  .Footer__Section-BreakLine {
    border-top: 1px solid black;
    margin-bottom: 50px;

    @media (min-width: ${theme.breakpoints.m}) {
      margin-bottom: ${theme.scale('50px', 0.3)};
    }
  }
`;

export const CopyrightFooterContainer = styled.div`
  display: flex;
  width: 100%;
  align-items: flex-start;
  flex-direction: column;

  @media (min-width: ${theme.breakpoints.m}) {
    position: absolute;
    bottom: -100px;
    right: 0;
    max-width: calc(100% - 335px);
  }
  
  @media (min-width: ${theme.breakpoints.l}) {
    max-width: calc(100% - 425px);
  }

  .LegalFooter__Content-Container {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-direction: row;

    p {
      padding-right: 2px;
      padding-left: 2px;
      text-decoration: underline;
    }
  }

  .LegalFooter__Content-Text {
    font-size: ${theme.fonts.xs};
    font-weight: 400;
    letter-spacing: 0.03em;
    font-family: ${theme.fontFamily.tertiary};
    margin-bottom: 0;

    @media (min-width: ${theme.breakpoints.m}) {
      margin-bottom: 5px;
      padding-right: ${theme.scale('10px')};
      padding-left: ${theme.scale('10px')};
      margin-bottom: 5px;
      font-size: ${theme.scale(theme.fonts.m_small)};
    }

    &.FieldOffice-Link {
      @media (min-width: ${theme.breakpoints.m}) {
        margin-top: 3px;
      }

      @media (min-width: ${theme.breakpoints.lg}) {
        margin-top: 0px;
      }
    }
  }

  .LegalFooter__Copyright-text {
    font-size: ${theme.fonts.xs};
    font-family: ${theme.fontFamily.tertiary};
    font-weight: 400;
    letter-spacing: 0.03em;
    margin-bottom: 5px;

    @media (min-width: ${theme.breakpoints.m}) {
      margin-bottom: 15px;
      white-space: nowrap;
      font-size: ${theme.scale(theme.fonts.m_small)};
    }
  }
`;

export const LegalItems = styled.div`
  width: 100%;
  margin: 20px 0 10px;

  @media (min-width: ${theme.breakpoints.m}) {
    margin: 0 0 10px;
    display: flex;
  }

  .LegalFooter__Content {
    padding-left: 2px;

    @media (min-width: ${theme.breakpoints.m}) {
      padding-left: 0px;
    }
  }
`;
